import * as React from 'react';
import { connect } from 'react-redux';
import Radium, { StyleRoot } from 'radium';
import {TShirtHeroLearnMoreHeader } from './TShirtHeroLearnMoreHeader';
import {browserHistory} from 'react-router';
import { TShirtHeroFooter } from './TShirtHeroFooter';
import { CSSProperties } from 'react';
import * as Tgcc from '../../tgccGlobal';
// Revised styles to include all updates and marketing suggestions
const pageStyles = {
    themeStyle: {
        // backgroundColor: '#121212',
        backgroundColor: '#000000',
        color: '#E0E0E0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
        fontFamily: '"Roboto", sans-serif', // Ensure consistency with the registration page
    } as CSSProperties,
    contentStyle: {
        maxWidth: '800px',
        textAlign: 'center',
        marginBottom: '50px',
    } as CSSProperties,
    headlineStyle: {
        fontSize: '2.5rem',
        fontWeight: 'bold',
        margin: '20px 0',
    } as CSSProperties,
    textStyle: {
        fontSize: '1.4rem', // Adjust according to the new requirement if needed
        lineHeight: '1.8',
        marginBottom: '20px',
    } as CSSProperties,
    highlightStyle: {
        color: '#FFC107',
    } as CSSProperties,
    buttonStyle: {
        backgroundColor: '#007bff', // Updated to blue as suggested
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        fontSize: '1rem',
        borderRadius: '5px',
        cursor: 'pointer',
        margin: '20px 1vw',
        ':hover': {
            backgroundColor: '#0056b3',
        },

    } as CSSProperties,

    sectionStyle: {
        marginTop: '30px',
        padding: '20px',
        borderRadius: '5px',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        color: '#E0E0E0',
    } as CSSProperties,
    listStyle: {
        textAlign: 'left',
        marginBottom: '20px',
    } as CSSProperties,
    listItemStyle: {
        marginBottom: '10px',
    } as CSSProperties,
    termsStyle: {
        fontSize: '0.8rem',
        cursor: 'pointer',
        marginTop: '20px',
    } as CSSProperties,
    emphasizedTextStyle: {
        fontSize: '1.6rem', // Even larger for more emphasis
        lineHeight: '2.0',
        fontWeight: 'bold', // Optional: if you want to make it bolder
        marginBottom: '20px',
    } as CSSProperties,
};

const twoColumnLayoutStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start', // Adjust this as needed to align items at the top
    width: '100%', // Ensure it spans the full width of the parent container
    maxWidth: '1200px', // Adjust based on your design requirements
    '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'center',
    },
} as CSSProperties;

// New style for the video container
const videoStyle: CSSProperties = {
    position: 'relative',
    width: '80%', // Use full width of the flex container or adjust as needed
    paddingBottom: '56.25%', // For 16:9 aspect ratio videos
    height: 0, // Height is zero because padding gives it height
    marginBottom: '20px', // Optional spacing
} as CSSProperties;

// Adjust the contentStyle to fit the new layout
const adjustedContentStyle: CSSProperties = {
    ...pageStyles.contentStyle, // Spread existing styles
    flex: '1 1 60%', // Adjust the flex-basis as needed
    maxWidth: '60%', // Limit content width, adjust based on your design requirements
    '@media (max-width: 768px)': {
        maxWidth: '100%',
    },
} as CSSProperties;
const iframeStyle: CSSProperties = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '80%',
    height: '100%',
} as CSSProperties;
const playButtonStyle: CSSProperties = {
    position: 'absolute',
    top: '50%',
    zIndex: 2,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    // Additional styling for the play button as needed
};
const contactHQButton: CSSProperties = {
    ...pageStyles.buttonStyle,
    backgroundColor: 'rgb(104, 147, 204)',
    ':hover': {
        backgroundColor: '#5375a3',
    },

};

const viewDesignsButtonStyle: CSSProperties = {
    ...pageStyles.buttonStyle, // Assuming it should look similar to other buttons
    backgroundColor: '#4CAF50', // A green color for distinction
    ':hover': {
        backgroundColor: '#388E3C',
    },
};

const winnerImageUrl = Tgcc.ResolveUrl('~/images/tshirt-hero-winner-spring2024.jpeg');
const superCowHead = Tgcc.ResolveUrl('~/images/SuperHeroCowHead.jpg');
const videoFile = Tgcc.ResolveUrl('~/images/TShirtHeroSocialVideo.mp4');
const captionPath = Tgcc.ResolveUrl('~/images/TShirtHeroSocialVideoCaptions.vtt');
class _TShirtHeroLearnMore extends React.Component<Tgcc.BaseProps, any> {
    constructor(props) {
        super(props);
        this.handlePause = this.handlePause.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
    }
    
    state = {
        showPlayButton: true,
        isPlaying: false,
        showControls: false,
    };
    

    componentDidMount() {
        this.setState({ showControls: true });
        const video = document.getElementById('tshirtHeroVideo') as HTMLVideoElement | null;
        if (video) {
            video.addEventListener('pause', this.handlePause);
            video.addEventListener('play', this.handlePlay);
        }
    }
    
    componentWillUnmount() {
        const video = document.getElementById('tshirtHeroVideo') as HTMLVideoElement | null;
        if (video) {
            video.removeEventListener('pause', this.handlePause);
            video.removeEventListener('play', this.handlePlay);
        }
    }
    
    handlePause = () => {
        this.setState({ showPlayButton: true });
    }
    
    handlePlay = () => {
        this.setState({ showPlayButton: false });
    }

    
    
    togglePlay = (e) => {
        e.stopPropagation(); // Prevent the click from bubbling up to the video container
    
        const video = document.getElementById('tshirtHeroVideo') as HTMLVideoElement | null;
        if (video) {
            if (video.paused || video.ended) {
                video.play();
                this.setState({ isPlaying: true, showControls: false }); // Consider if you want controls hidden on play
            } else {
                video.pause();
                this.setState({ isPlaying: false, showControls: true });
            }
        }
    };
    
    
    
    handleVideoTap = () => {
        // Only toggle the visibility of controls, don't play/pause the video here
        this.setState(prevState => ({ showControls: !prevState.showControls }));
    };
    
    openRegister = () =>{browserHistory.push(Tgcc.Routes.TShirtHero)} 
    openTerms = () =>{browserHistory.push(Tgcc.Routes.TShirtHeroTerms)} 

  

    render() {
        return (
            <Radium.StyleRoot>
                <div style={pageStyles.themeStyle}>
                    <TShirtHeroLearnMoreHeader />
                    <div style={{ maxWidth: '100%', textAlign: 'center', marginBottom: '12vh' }}>
                        <h2>Congratulations to Delta Tau Delta at Morehead State University!</h2>
                        <img src={winnerImageUrl} alt="T-Shirt Contest Winner" style={{ width: '80%', height: 'auto' }} />
                        <p>Congratulations to Delta Tau Delta at Morehead State University for their outstanding creativity! They've secured the top prize of $1000 for their group. <a href="https://www.tiktok.com/t/ZPRTKB1ax/" target="_blank" rel="noopener noreferrer" style={{ color: '#FFC107', fontWeight: 'bold', textDecoration: 'underline' }}> <br></br>Click here to see their winning entry!</a></p>
                        </div>

                    <div style={twoColumnLayoutStyle}>
                        <div style={videoStyle}>
                        {/* {this.state.showControls && (
                                <div style={playButtonStyle} onClick={this.togglePlay}>
                                    {/* Render play or pause icon based on whether the video is playing */}
                                    {/* {!this.state.isPlaying ? (
                                        // Play icon
                                        <svg viewBox="0 0 200 200" alt="Play video" style={{ width: 100, height: 100 }}>
                                            <polygon points="70, 55 70, 145 145, 100" fill="#fff" />
                                        </svg>
                                    ) : (
                                        // Pause icon
                                        <svg viewBox="0 0 200 200" alt="Pause video" style={{ width: 100, height: 100 }}>
                                            <rect x="60" y="55" width="30" height="90" fill="#fff" />
                                            <rect x="110" y="55" width="30" height="90" fill="#fff" />
                                        </svg>
                                    )}
                                </div> */}
                            {/* )} */}
                            {/* <iframe
                                src="https://www.youtube.com/embed/aeSmcEpoZ8E"
                                style={iframeStyle}
                                title="Our Video Player"
                                frameBorder="0"
                                allowFullScreen>
                            </iframe> */}
                            <img src={superCowHead} alt="Super Cow" style={{ width: '80%', height: 'auto' }} />

                        </div>
    


                        <div style={adjustedContentStyle}>
                            <h1 style={pageStyles.headlineStyle}>Welcome to Cowtopia!</h1>
                            <p style={pageStyles.emphasizedTextStyle}>
                                Register now to unlock the best offers in Cowtopia for your group. Get ready to embark on your next adventure with the help of your super sidekick—an Account Manager who will contact you soon after you register. Stay tuned for the return of our T-Shirt Hero Challenge this fall!
                            </p>

                        {/* <div style={adjustedContentStyle}>
                        <h1 style={pageStyles.headlineStyle}>Join the T-Shirt Hero Challenge!</h1>
                        <p style={pageStyles.emphasizedTextStyle}>Register now and get ready to unleash your inner superhero. Confirm your identity with your super sidekick (an Account Manager will contact you within the first few days of registering) and receive a box packed with your super swag. It's time to suit up!</p> */}
                        {/* <p style={pageStyles.textStyle}>Suit up, showcase your creativity, and capture a moment that will make the world laugh or awe. Whether it's a video or a picture, post it on <span style={pageStyles.highlightStyle}>Instagram or TikTok</span> using the hashtag <span style={pageStyles.highlightStyle}>#TShirtHero</span>.</p>
                        <p style={pageStyles.textStyle}>The most creative or funniest entry wins <span style={pageStyles.highlightStyle}>$1000 in group apparel</span>. Don’t miss out! The winner will be announced by <span style={pageStyles.highlightStyle}>the end of the semester</span>.</p> */}
                        <button onClick={this.openRegister} key="register" style={pageStyles.buttonStyle}>Register Now</button>
                         {/* "Contact HQ" Button */}
                         <button 
                            style={contactHQButton} 
                            key="contact"
                            onClick={() => window.location.href = 'mailto:sales@grafcow.com'}>
                            Contact HQ
                        </button>

                        <button 
                                style={viewDesignsButtonStyle} 
                                onClick={() => browserHistory.push('/campus/designs')}>
                                View Designs
                        </button>

                        {/* <div style={pageStyles.sectionStyle}>
                            <h2 style={pageStyles.headlineStyle}>How It Works</h2>
                            <ul style={pageStyles.listStyle}>
                                <li style={pageStyles.listItemStyle}>Register and get your superhero gear delivered to your doorstep.</li>
                                <li style={pageStyles.listItemStyle}>Showcase your superhero persona. Think outside the box: the sky's the limit!</li>
                                <li style={pageStyles.listItemStyle}>Share your hero moment on social media. Remember, creativity and humor are your superpowers here.</li>
                            </ul>

                            <h2 style={pageStyles.headlineStyle}>Rules & Guidelines</h2>
                            <p style={pageStyles.textStyle}>To ensure a fair and fun challenge for everyone, please follow these rules:</p>
                            <ul style={pageStyles.listStyle}>
                                <li style={pageStyles.listItemStyle}>Keep content family-friendly and respectful.</li>
                                <li style={pageStyles.listItemStyle}>Original content only. Reposts or copied ideas will not be considered.</li>
                                <li style={pageStyles.listItemStyle}>One entry per group. Make it count and show us your best moment!</li>
                                <li style={pageStyles.listItemStyle}>Follow us on Instagram and TikTok for inspiration, updates, and more.</li>
                            </ul>
                        </div> */}

                        {/* Terms and Conditions Link */}
                        {/* <div style={pageStyles.termsStyle}>
                            <a onClick={this.openTerms} target="_blank" rel="noopener noreferrer">
                                Terms and Conditions
                            </a>
                        </div> */}
                        </div>
                    </div>
                    <TShirtHeroFooter />
                </div>
            </Radium.StyleRoot>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => ({
    // Implement state mapping if necessary
});

export var TShirtHeroLearnMore = connect(mapStateToProps)(Radium(_TShirtHeroLearnMore));
